import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight, faQuestion, faTimes } from '@fortawesome/free-solid-svg-icons';

//utils
import { hasText, isCEP,buscaEndereco, maskDate, isDate, openCorreios } from './../../../utils/utils';

//services
import serviceUsuarios from './../../../services/usuarios';
import serviceCatalogos from './../../../services/catalogos';

//redux
import { actions as actionsSite } from './../../../redux/actions/site';
import { actions as actionsAuth } from './../../../redux/actions/auth';
import { useDispatch } from 'react-redux';

import PoliticaPrivacidade from './../PoliticaPrivacidade';
import TermosAceite from './../TermosAceite';
import CheckBox from '../../painel/form/generics/CheckBox';

const Completar = props => {

    const dispatch = useDispatch();
    const { register, handleSubmit, errors, setValue, setError } = useForm();
    const [showPolitica, setShowPolitica] = useState(false);
    const [showTermos, setShowTermos] = useState(false);
    const [catalogosEscolhidos, setCatalogosEscolhidos] = useState([]);
    const [catalogos, setCatalogos] = useState([]);

    const getCatalogos = useCallback(async () => {
        const res = await serviceCatalogos.get(
            `?catalogo=NULL&sort=apelido&active=true`
          );
          const catalogosColunasArr = res.rows.map((e) => {
            e.apelido = e.apelido.toString().toUpperCase();
            return e;
          }).sort((a,b)=>(a.apelido > b.apelido ? 1 : -1));
        setCatalogos(catalogosColunasArr);
    }, []);

    useEffect(() => {
        getCatalogos();
    }, [getCatalogos]);

    const enviarDados = async data => {
        dispatch(actionsSite.setLoadingMsg("Completando cadastro..."));
        const res = await serviceUsuarios.completarCadastro(data);
        dispatch(actionsSite.setLoadingMsg(res.msg));
        if (!res.erro) {
            await dispatch(actionsAuth.setProfileByToken());
        }
        setTimeout(async () => {
            dispatch(actionsSite.setLoadingMsg(""));
            
        }, 3000);
    }

    const getAddress = async cep => {
        try {
            if (isCEP(cep)) {
                const address = await buscaEndereco(cep);
                if (address) {
                    setValue("endereco", address.street);
                    setValue("bairro", address.neighborhood);
                    setValue("cidade", address.city);
                    setValue("uf", address.state);
                    document.querySelector("#endereco").classList.add('hasText');
                    document.querySelector("#bairro").classList.add('hasText');
                    document.querySelector("#cidade").classList.add('hasText');
                    document.querySelector("#uf").classList.add('hasText');
                }
            }
        } catch (e) {
            setError("cep", {
                type: "invalid",
            });
        }
    }


    const setCatalogo = (id, checked) => {
        const _catalogosEscolhidos = [...catalogosEscolhidos];
        if (_catalogosEscolhidos.includes(id)) {
            const index = _catalogosEscolhidos.indexOf(id);
            _catalogosEscolhidos.splice(index, 1);
        } else {
            _catalogosEscolhidos.push(id);
        }
        setCatalogosEscolhidos(_catalogosEscolhidos);
    }

    const renderCatalogosCheckbox = () => {
        return catalogos.map((row, index) => {
            if(row.catalogo === null){
                return <CheckBox key={index} label={row.apelido.toUpperCase()} value={row._id} callback={setCatalogo} />
            }
            return null;
        });
    }

    return (
        <div className="form">
                <form className="formModule branco" onSubmit={handleSubmit(enviarDados)}>
                    <h3 className="tituloEtapa">3ª Etapa - Dados pessoais</h3>
                    <div className="break"></div>
                    <div className={errors.dataNascimento ? "field error" : "field"}>
                        <input name="dataNascimento" id="dataNascimento" maxLength={10} onKeyUp={(e) => { maskDate(e); hasText(e) }} type="text"
                            ref={register({ required: true, validate: { isDate: value => isDate(value) } })} />
                        <label htmlFor="dataNascimento">Data de Nascimento</label>
                    </div>

                    <div className={errors.genero ? "field error" : "field"}>
                        <select name="genero" id="genero" className="hasText" ref={register()}>
                            <option value="F">Feminino</option>
                            <option value="M">Masculino</option>
                        </select>
                        <label htmlFor="genero">Gênero</label>
                    </div>
                    <div className="break"></div>
                    <div className={errors.rg ? "field error" : "field"}>
                        <input name="rg" id="rg" onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                        <label htmlFor="rg">RG</label>
                    </div>

                    <div className={errors.orgaoEmissor ? "field error" : "field"}>
                        <input name="orgaoEmissor" id="orgaoEmissor" onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                        <label htmlFor="orgaoEmissor">Órgão emissor</label>
                    </div>
                    <div className="break"></div>
                    <div className={errors.nomeMae ? "field error" : "field"}>
                        <input name="nomeMae" id="nomeMae" onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                        <label htmlFor="nomeMae">Nome da mãe</label>
                    </div>
                    <div className={errors.nomePai ? "field error" : "field"}>
                        <input name="nomePai" id="nomePai" onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                        <label htmlFor="nomePai">Nome do pai</label>
                    </div>
                    <div className="break"></div>
                    <h3 className="tituloEtapa mt20">Endereço</h3>
                    <div className="break"></div>

                    <div className={errors.cep ? "field error cep" : "field cep"}>
                        <input name="cep" id="cep" onKeyUp={(e) => hasText(e)} type="text" maxLength={9} onChange={e => getAddress(e.target.value)}
                            ref={register({ required: true, validate: { isCEP: value => isCEP(value), isNumeric: value => !isNaN(value) } })} />
                        <label htmlFor="cep">CEP</label>
                    </div>
                    <div className="field noBorder noBg naoSabeCep">
                        <button type="button" onClick={() => openCorreios()}><FontAwesomeIcon icon={faQuestion} /> Não sabe o CEP</button>
                    </div>
                    <div className="break"></div>
                    <div className={errors.endereco ? "field readonly error" : "field readonly"}>
                        <input name="endereco" id="endereco" readOnly={true} onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                        <label htmlFor="endereco">Endereço</label>
                    </div>
                    <div className={errors.numero ? "field error numero" : "field numero"}>
                        <input name="numero" id="numero" onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                        <label htmlFor="numero">Nº</label>
                    </div>


                    <div className={errors.complemento ? "field error" : "field"}>
                        <input name="complemento" id="complemento" onKeyUp={(e) => hasText(e)} type="text" ref={register()} />
                        <label htmlFor="complemento">Complemento</label>
                    </div>
                    <div className="break"></div>
                    <div className={errors.pontoReferencia ? "field error" : "field"}>
                        <input name="pontoReferencia" id="pontoReferencia" onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                        <label htmlFor="pontoReferencia">Ponto de Referência</label>
                    </div>
                    <div className="break"></div>
                    <div className={errors.bairro ? "field error readonly" : "field readonly"}>
                        <input name="bairro" id="bairro" readOnly={true} onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                        <label htmlFor="bairro">Bairro</label>
                    </div>

                    <div className={errors.cidade ? "field error readonly" : "field readonly"}>
                        <input name="cidade" id="cidade" readOnly={true} onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                        <label htmlFor="cidade">Cidade</label>
                    </div>
                    <div className={errors.uf ? "field error uf readonly" : "field uf readonly"}>
                        <input name="uf" id="uf" readOnly={true} maxLength={2} onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                        <label htmlFor="uf">UF</label>
                    </div>

                    <div className="break"></div>
                    <h3 className="tituloEtapa mt20">Quais catálogos você quer revender?</h3>
                    <div className="break"></div>
                    <input name="catalogos" id="catalogos" type="hidden" value={catalogosEscolhidos.join(",")} ref={register({ required: true })} />
                    {renderCatalogosCheckbox()}
                    <div className="break"></div>

                    <div className="break"></div>
                    <h3 className="tituloEtapa mt20">Outras informações</h3>
                    <div className="break"></div>

                    <div className={errors.ddd ? "field ddd error" : "field ddd"}>
                        <input name="ddd" id="ddd" maxLength={2} onKeyUp={(e) => { hasText(e) }} type="text" ref={register({ validate: { isNumeric: value => !isNaN(value) } })} />
                        <label htmlFor="ddd">DDD</label>
                    </div>
                    <div className={errors.telefone ? "field error" : "field"}>
                        <input name="telefone" id="telefone" maxLength={9} onKeyUp={(e) => { hasText(e) }} type="text" ref={register({ validate: { isNumeric: value => !isNaN(value) } })} />
                        <label htmlFor="telefone">Nº Telefone Residencial</label>
                    </div>

                    <div className={errors.dddRecado ? "field ddd error" : "field ddd"}>
                        <input name="dddRecado" id="dddRecado" maxLength={2} onKeyUp={(e) => { hasText(e) }} type="text" ref={register({ required: true, validate: { isNumeric: value => !isNaN(value) } })} />
                        <label htmlFor="dddRecado">DDD</label>
                    </div>
                    <div className={errors.telefoneRecado ? "field error" : "field"}>
                        <input name="telefoneRecado" id="telefoneRecado" maxLength={9} onKeyUp={(e) => { hasText(e) }} type="text" ref={register({ required: true, validate: { isNumeric: value => !isNaN(value) } })} />
                        <label htmlFor="telefoneRecado">Nº Telefone Recado</label>
                    </div>
                    <div className="break"></div>
                    <div className={errors.nomeRecado ? "field error" : "field"}>
                        <input name="nomeRecado" id="nomeRecado" onKeyUp={(e) => { hasText(e) }} type="text" ref={register({ required: true })} />
                        <label htmlFor="nomeRecado">Nome de recado</label>
                    </div>

                    <div className={errors.comoConheceu ? "field error" : "field"}>
                        <select name="comoConheceu" id="comoConheceu" className="hasText" ref={register({ required: true })}>
                            <option value="">Selecione</option>
                            <option>Indicação</option>
                            <option>Já sou Consultor(a)</option>
                            <option>Facebook</option>
                            <option>Google</option>
                            <option>Outras mídias</option>
                        </select>
                        <label htmlFor="comoConheceu">Como nos conheceu?</label>
                    </div>
                    <div className="break"></div>
                    <div className={errors.quemIndicou ? "field error" : "field"}>
                        <input name="quemIndicou" id="quemIndicou" onKeyUp={(e) => { hasText(e) }} type="text" ref={register()} />
                        <label htmlFor="quemIndicou">Quem indicou / Mídia social</label>
                    </div>
                    <div className="break"></div>
                    <div className={errors.obs ? "field error" : "field"}>
                        <input name="obs" id="obs" onKeyUp={(e) => { hasText(e) }} type="text" ref={register()} />
                        <label htmlFor="obs">Observações</label>
                    </div>

                    <div className="break"></div>
                    <div className={errors.aceiteTermos ? "field aceite error" : "field aceite"}>
                        <label>
                            <input type="checkbox" name="aceiteTermos" id="aceiteTermos" ref={register({ required: true })} />
                            <span>
                                Li e concordo com a <span className="link" onClick={() => setShowPolitica(true)}>política de privacidade</span> e com os
                                <span className="link" onClick={() => setShowTermos(true)}> termos de uso </span> do site Leka Catálogos.
                            </span>
                        </label>
                    </div>
                    {showPolitica && <PoliticaPrivacidade />}
                    {showTermos && <TermosAceite />}
                    <div className="break"></div>
                    <div className="acoes">
                        <button type="submit" className="salvar"><FontAwesomeIcon icon={faArrowAltCircleRight} /> Completar cadastro</button>
                    </div>
                </form>

                {errors && Object.keys(errors).length > 0 &&
                    <div className="erros">
                        {errors.dataNascimento?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Data de nascimento</div>}
                        {errors.dataNascimento?.type === 'isDate' && <div><FontAwesomeIcon icon={faTimes} /> A Data de nascimento está inválida</div>}
                        {errors.rg?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo RG</div>}
                        {errors.orgaoEmissor?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Órgão emissor</div>}
                        {errors.nomeMae?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Nome da mãe</div>}
                        {errors.nomePai?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Nome do pai</div>}
                        {errors.cep?.type === 'isNumeric' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o CEP com apenas números</div>}
                        {errors.cep?.type === 'isCEP' && <div><FontAwesomeIcon icon={faTimes} /> Não é um CEP válido</div>}
                        {errors.cep?.type === 'invalid' && <div><FontAwesomeIcon icon={faTimes} /> Não é um CEP válido</div>}

                        {errors.pontoReferencia?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Ponto Referência</div>}
                        {errors.ddd?.type === 'isNumeric' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo DDD Residencial com apenas números</div>}
                        {errors.telefone?.type === 'isNumeric' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Telefone Residencial com apenas números</div>}
                        {errors.dddRecado?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo DDD Recado</div>}
                        {errors.dddRecado?.type === 'isNumeric' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo DDD Recado com apenas números</div>}
                        {errors.telefoneRecado?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Telefone Recado</div>}
                        {errors.telefoneRecado?.type === 'isNumeric' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Telefone Recado com apenas números</div>}

                        {errors.nomeRecado?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Nome de recado</div>}
                        {errors.comoConheceu?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Preencha o campo Como nos conheceu</div>}
                        {errors.aceiteTermos?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Aceite os termos</div>}
                        {errors.catalogos?.type === 'required' && <div><FontAwesomeIcon icon={faTimes} /> Escolha pelo menos 1 catálogo</div>}
                    </div>
                }
            </div>
    );
};

export default Completar;